//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TaxDisplayItem extends ItemBase {
    ID: string | null = null;
    TaxDefinitionID: string | null = null;
    Amount: number = 0;
    Name: string | null = null;
    Rate: number = 0;
    CashID: string | null = null;
    ReceivableID: string | null = null;

    constructor(initializer?: Partial<TaxDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TaxDisplayItem";
}
